import { createStore } from 'vuex'
import alert from './modules/alert'
import voucher from './modules/voucher'
import campaign from './modules/campaign'

export default createStore({
    modules: {
        voucher,
        campaign,
        alert,
    }
})